import { Box, Typography } from '@mui/material'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useThemeMode } from '../../../theme'

const TICKER_INTERVAL_MS = 5000

export const HotNewsTicker = () => {
  const { palette } = useThemeMode()
  const { i18n } = useTranslation()
  const language = i18n.language

  const coninfoMessages = useSelector((state) => state?.coninfoMessages?.data)

  const [currentIndex, setCurrentIndex] = useState(0)

  const items = useMemo(() => {
    return (coninfoMessages ?? [])
      .filter((m) => m?.language === language)
      .flatMap((m) => m?.text ?? [])
      .filter(Boolean)
  }, [coninfoMessages, language])

  const itemsRef = useRef(items)
  useEffect(() => { itemsRef.current = items }, [items])

  useEffect(() => {
    if (items.length === 0) return
    setCurrentIndex(0)
    const id = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % itemsRef.current.length)
    }, TICKER_INTERVAL_MS)
    return () => clearInterval(id)
  }, [items.length])

  if (items.length === 0) return null

  const text = items[currentIndex] ?? items[0]

  return (
    <Box sx={{ width: '100%', height: '36px', display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
      <Box sx={{ flex: 1, overflow: 'hidden', height: '100%', display: 'flex', alignItems: 'center', px: '10px' }}>
        <Typography
          key={currentIndex}
          sx={{
            fontSize: '0.82rem',
            color: palette.textColor,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
            animation: 'ticker-slide 0.4s ease-out',
            '@keyframes ticker-slide': {
              '0%': { opacity: 0, transform: 'translateY(-16px)' },
              '100%': { opacity: 1, transform: 'translateY(0)' }
            }
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  )
}
